<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="callSubmit">
		<v-select
			v-model="form.role"
			required
			:items="roles"
			label="סוג משתמש"
		/>
		<organizations-select
			v-if="isAdmin && form.role == 2"
			v-model="form.organization_id"
		/>
		<smart-input
			v-model="form.name"
			required
			:error="inputErrors.name"
			label="שם פרטי"
		/>
		<smart-input
			v-model="form.last_name"
			:error="inputErrors.last_name"
			label="שם משפחה"
		/>
		<smart-input
			v-model="form.email"
			required
			:error="inputErrors.email"
			type="text"
			label="שם משתמש"
		/>
		<v-checkbox
			v-if="!isNew"
			v-model="hidePassword"
			label="שנה סיסמה"
		/>
		<smart-input
			v-if="hidePassword || isNew"
			v-model="form.password"
			required
			:error="inputErrors.password"
			type="password"
			label="סיסמה"
			minlength="6"
		/>
		<v-select
			v-if="form.role == 3"
			v-model="form.company_id"
			required
			:items="companies"
			item-text="name"
			item-value="id"
			label="מרכז"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import UserModule from "src/store/modules/User.module";
import FormView from "src/mixins/FormView";
import { types as CompaniesTypes } from "src/store/modules/Company.module";
import OrganizationsSelect from "dev/view/organizations/OrganizationsSelect";
import { types as roleTypes } from "dev/config/roles";

export default {
	name: "UserForm",
	components: { OrganizationsSelect },
	props: [],
	data () {
		return {
			form: {
				name: null,
				organization_id: null,
			},
			roles: [
				{ text: "מנהל ארגון", value: 2 },
				{ text: "משתמש מרכז", value: 3 },
			],
			hidePassword: false,
		};
	},
	mixins: [new FormView(UserModule, "user")],
	computed: {
		isNew () {
			return !this.user.id;
		},
		isAdmin () {
			return this.$store.getters.isAdmin;
		},
		companies () {
			return this.$store.state.CompanyModule.companies;
		},
	},
	watch: {
		"form.role" () {
			if (this.role == roleTypes.MANAGER) {
				this.form.organizations = null;
			} else if (this.role == roleTypes.USER) {
				this.form.companies = null;
			}
		},
	},
	created () {
		this.$store.dispatch(CompaniesTypes.FETCH);
	},
	methods: {
		async callSubmit (e) {
			await this.onSubmit(e);
		},
		onError () {
			// automatic
		},
	},
};
</script>

<style>

</style>
